import { useEffect, useRef, useState } from 'react';
import { memberSummaryApi } from '@formosa/shared/api/im';
import { collectMemberIds, loadMemberSummaryIndex } from './memberDisplayModel';

export default function useMemberDisplayNames(memberIds) {
  const ids = collectMemberIds(memberIds);
  const key = ids.join(',');
  const [summaries, setSummaries] = useState({});
  const generation = useRef(0);

  useEffect(() => {
    const requestId = ++generation.current;
    const currentIds = key ? key.split(',') : [];
    if (!currentIds.length) {
      setSummaries({});
      return undefined;
    }
    let cancelled = false;
    loadMemberSummaryIndex(currentIds, {
      batch: (chunk) => memberSummaryApi.batch(chunk),
      isCurrent: () => !cancelled && requestId === generation.current,
    }).then((index) => {
      if (index == null) return;
      setSummaries(index);
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return summaries;
}
